import { useDispatch } from 'react-redux';

import { setAuthenticated } from 'theSource/features/Login/services';
import { useApiMutation } from 'theSource/utils';
import { PingResponseDto, PingRequestDto } from './types';
import { PING_QUERY_KEY, PING_ENDPOINT } from './utils';

export const useAuthenticationMutation = () => {
  const dispatch = useDispatch();

  const { isLoading: isAuthenticating, mutate: authenticate } = useApiMutation<
    PingResponseDto,
    unknown,
    PingRequestDto
  >({
    queryKey: PING_QUERY_KEY,
    method: 'post',
    endpoint: PING_ENDPOINT,
    onSuccess: () => dispatch(setAuthenticated(true)),
    onError: () => dispatch(setAuthenticated(false)),
    showSuccessSnackbar: false,
    showErrorSnackbar: false,
  });

  return { isAuthenticating, authenticate };
};
